export default "__VITE_ASSET__DvoAvsP9__"